import type { DomaineId } from './accueil-config';

export type StatutParcours = 'beta' | 'brouillon';

export type Parcours = {
  slug: string;
  titre: string;
  fichier: string;
  statut: StatutParcours;
};

export type OutilEnseignant = Parcours;

const RACINE_PUBLIQUE = '/mini-apps/francais-college';

export const PARCOURS: ReadonlyArray<Parcours> = [
  { slug: 'essentiel-une-phrase', titre: 'L’essentiel en une phrase', fichier: 'essentiel_une_phrase.html', statut: 'beta' },
  { slug: 'huit-mots-semaine', titre: 'Huit mots par semaine', fichier: 'huit_mots_semaine.html', statut: 'beta' },
  { slug: 'episode-2-lexique', titre: 'Épisode 2 · Rideau !', fichier: 'episode_lexique.html', statut: 'beta' },
  { slug: 'episode-1', titre: 'Le Gommeur · épisode 1', fichier: 'episode1.html', statut: 'beta' },
  { slug: 'lacets-recit', titre: 'Défaire et refaire les lacets', fichier: 'parcours_lacets_recit.html', statut: 'brouillon' },
  { slug: 'carnet-phrases', titre: 'Le carnet de phrases', fichier: 'parcours_carnet_phrases.html', statut: 'brouillon' },
  { slug: 'copie-eclair', titre: 'La copie éclair', fichier: 'parcours_copie_eclair.html', statut: 'brouillon' },
  { slug: 'geste-5-minutes', titre: 'Le geste en 5 minutes', fichier: 'parcours_geste_5_minutes.html', statut: 'brouillon' },
  { slug: 'bilan', titre: 'Bilan de positionnement 6e', fichier: 'bilan_positionnement_6e.html', statut: 'beta' },
];

export const OUTILS_ENSEIGNANT: ReadonlyArray<OutilEnseignant> = [
  { slug: 'relecture-lexique', titre: 'Relecture — Lexique', fichier: 'relecture_module_lexique.html', statut: 'beta' },
  { slug: 'relecture-comprehension', titre: 'Relecture — Compréhension', fichier: 'relecture_module_comprehension.html', statut: 'beta' },
  { slug: 'relecture-connecteurs', titre: 'Relecture — Connecteurs', fichier: 'relecture_module_connecteurs.html', statut: 'brouillon' },
];

export const PARCOURS_PAR_DOMAINE: Readonly<Record<DomaineId, ReadonlyArray<string>>> = {
  fluence: [],
  comprehension: ['essentiel-une-phrase'],
  vocabulaire: ['huit-mots-semaine', 'episode-2-lexique'],
  grammaire: [],
  ecriture: ['episode-1', 'lacets-recit', 'carnet-phrases', 'copie-eclair', 'geste-5-minutes'],
  oral: [],
  culture: [],
};

export const A_VENIR_PAR_DOMAINE: Readonly<Partial<Record<DomaineId, ReadonlyArray<string>>>> = {
  ecriture: ['Rédaction, réécriture'],
};

export const DOMAINES_AVEC_PARCOURS: ReadonlyArray<DomaineId> = (
  Object.keys(PARCOURS_PAR_DOMAINE) as DomaineId[]
).filter((id) => PARCOURS_PAR_DOMAINE[id].length > 0);

export function parcoursDuDomaine(id: DomaineId): ReadonlyArray<Parcours> {
  return PARCOURS_PAR_DOMAINE[id].flatMap((slug) => PARCOURS.find((p) => p.slug === slug) ?? []);
}

export function trouverParcours(slug: string | undefined): Parcours | undefined {
  return [...PARCOURS, ...OUTILS_ENSEIGNANT].find((p) => p.slug === slug);
}

export function trouverDomaine(valeur: string | undefined): DomaineId | undefined {
  return DOMAINES_AVEC_PARCOURS.find((id) => id === valeur);
}

export function urlFichier(parcours: Parcours): string {
  return `${RACINE_PUBLIQUE}/${parcours.fichier}`;
}
